import request from '../utils/request'

export default {
  // 获取所有权限
  findAll(params) {
    return request.get('/api/permission', { params })
  },
  
  // 根据ID获取权限
  findById(id) {
    return request.get(`/api/permission/${id}`)
  },
  
  // 添加权限
  add(permission) {
    return request.post('/api/permission', permission)
  },
  
  // 更新权限
  update(id, permission) {
    return request.put(`/api/permission/${id}`, permission)
  },
  
  // 删除权限
  delete(id) {
    return request.delete(`/api/permission/${id}`)
  },
  
  // 根据角色ID查询权限
  findByRoleId(roleId) {
    return request.get(`/api/permission/role/${roleId}`)
  },
  
  // 根据用户ID查询权限
  findByUserId(userId) {
    return request.get(`/api/permission/user/${userId}`)
  },

  // 检查权限编码是否存在
  checkPermissionCode(params) {
    return request.get('/api/permission/checkPermissionCode', { params })
  },
}
